import { SxProps, Theme } from '@mui/material';

/**
 * Styles for ReportHeaderComponent
 * Uses theme values from MuiProvider for consistent styling
 */

export const reportHeaderStyles = {
  container: (theme: Theme) => ({
    position: 'sticky',
    top: 0,
    width: '100%',
    zIndex: 1,
  }) as SxProps<Theme>,

  gridCell: (theme: Theme) => ({
    padding: '10px 10px 10px 0',
  }) as SxProps<Theme>,
};

export default reportHeaderStyles;
